module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "map-area section-padding cpinfo_section1 section"
  }, [_c('div', {
    staticClass: "chanpin_info"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.cpinfo.title) + "\n        ")]), _vm._v(" "), _c('P', {
    staticClass: "p3 animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s",
      "visibility": "visible"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.cpinfo.description)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "banner-sunb animate zoomInRight animated",
    staticStyle: {
      "animation-duration": "2s",
      "animation-delay": "0.5s",
      "visibility": "visible"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": _vm.newurl + _vm.cpinfo.ico
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-sunc animate fadeInLeft animated"
  }, [_c('div', {
    staticClass: "ccp1"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.newurl + _vm.cpinfo.ico
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "map-area section-padding cpinfo_section2 section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jscs_s02"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ipahyyyzzz",
    staticStyle: {
      "width": "30%",
      "margin-right": "10%",
      "float": "right",
      "font-size": "14px",
      "color": "#4bbfbc"
    }
  }, [_c('div', {
    staticClass: "bianhua003",
    staticStyle: {
      "float": "right",
      "width": "250px",
      "height": "100px",
      "margin-top": "50px"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.newurl + _vm.cpinfo.ext_zhegnshu,
      "target": "_blank"
    }
  }, [(_vm.cpinfo.ext_zhegnshu) ? _c('div', {
    staticStyle: {
      "width": "40%",
      "float": "left",
      "text-align": "center",
      "cursor": "pointer"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("产品手册下载")])]) : _vm._e()]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.newurl + _vm.cpinfo.ext_c3,
      "target": "_blank"
    }
  }, [(_vm.cpinfo.ext_c3) ? _c('div', {
    staticStyle: {
      "width": "40%",
      "float": "right",
      "text-align": "center",
      "cursor": "pointer"
    }
  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v("证书下载")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "jscs_s03"
  }, [_c('div', {
    staticClass: "zuozuozuo",
    staticStyle: {
      "float": "left",
      "width": "50%"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.cpinfo.ext_xingneng)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "youyouyou",
    staticStyle: {
      "float": "right",
      "width": "50%"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.cpinfo.content)
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jscs_s01"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/cpinfoban.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ccvccdiv",
    staticStyle: {
      "width": "50%",
      "margin-left": "10%",
      "float": "left"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/biaoqian.jpg"
    }
  }), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "jishucanshuziti",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("技术参数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": "/static/assets/images/wenjian.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": "/static/assets/images/wenjian.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74d23633"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Chanpin.vue
// module id = 110
// module chunks = 0